interface SplitFilename {
  baseName: string;
  /** The text after the last dot, without the dot. Null when there is none. */
  extension: string | null;
}

/**
 * Splits a filename at its last dot: `report.final.pdf` becomes
 * `report.final` and `pdf`. A name with no dot (`Makefile`), only a leading
 * dot (`.env`), or a trailing dot has no extension.
 */
export default function splitFilename(filename: string): SplitFilename {
  const lastDot = filename.lastIndexOf(".");
  if (lastDot <= 0 || lastDot === filename.length - 1) {
    return { baseName: filename, extension: null };
  }
  return {
    baseName: filename.slice(0, lastDot),
    extension: filename.slice(lastDot + 1),
  };
}
